import { render, staticRenderFns } from "./CourseMappingSaveModal.vue?vue&type=template&id=b12c915e&scoped=true"
import script from "./CourseMappingSaveModal.vue?vue&type=script&lang=js"
export * from "./CourseMappingSaveModal.vue?vue&type=script&lang=js"
import style0 from "./CourseMappingSaveModal.vue?vue&type=style&index=0&id=b12c915e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c915e",
  null
  
)

export default component.exports